import styled from "styled-components";

const ChoosePlayButton = () => {
  const scrollToFeaturedScenarios = () => {
    const position = document.getElementById('featured-scenarios')?.offsetTop;
    if (position) {
      window.scrollTo({ top: position - 100, behavior: 'smooth' });
    }
  };

  return (
    <div className="mt-8 flex w-full justify-center">
      <Button
        onClick={scrollToFeaturedScenarios}
      >
        Choose your play
      </Button>
    </div>
  );
};

export default ChoosePlayButton;


const Button = styled.button`
  background-color: rgba(255, 126, 85, 1);
  color: white;
  text-transform: uppercase;
  padding: 20px 32px;
  border-radius: 200px;
  font-family: Nunito Sans;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  box-shadow: 0px 12px 40px 0px rgba(255, 126, 85, 0.12);
`;
